import './main.scss';
import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import decodeToken from '../../../../utils/decode-token';
import Wadsworth from '../../../organisms/role-hac/wadsworth/wadsworth';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Collapse } from '@mui/material';
import ModalHacShowContact from '../../../organisms/role-hac/modal-hac-show-contact/modal-hac-show-contact.js';
import {
  electricHero,
  hacLandingExperience01,
  hacLandingExperience02,
  hacLandingExperience03
} from '../../../../assets/img/landing';
import { partnerIntegration } from '../../../../assets/img/landing';
import Footer from '../../../organisms/footer/footer';
//import ModalWindow from '../../../organisms/common/modal/modal';
//import apiClient from '../../../../utils/apiClient';
import { applyLanguage, getPreferredLanguage } from '../../../../i18n';
import LandingElectricSection from './sections/landing-electric/LandingElectricSection.js';
import PartnerIntegrationSection from './sections/partner-integration/PartnerIntegrationSection.js';

//const getSurveyModalSessionKey = (surveyId) => `survey_modal_shown_${surveyId}`;

const MainHac = () => {
  const { t } = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const decoded = token ? decodeToken(token) : null;
  const role = decoded?.role || null;
  const hacId = decoded?.id || decoded?.hacId || decoded?.user_id || null;

  const navigate = useNavigate();

  const [languageReady, setLanguageReady] = useState(false);

  /*
  const [openSurveyModal, setOpenSurveyModal] = useState(false);
  const [activeSurvey, setActiveSurvey] = useState(null);
  const [surveySubmission, setSurveySubmission] = useState(null);
  */

  const [openModal, setOpenModal] = useState(false);
  const [activeBenefit, setActiveBenefit] = useState(null);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [activeExperience, setActiveExperience] = useState(null);

  const showContact = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    let mounted = true;

    const syncLanguage = async () => {
      try {
        const preferredLanguage = getPreferredLanguage();
        await applyLanguage(preferredLanguage);

        if (mounted) {
          setLanguageReady(true);
        }
      } catch (error) {
        if (mounted) {
          setLanguageReady(true);
        }
      }
    };

    syncLanguage();

    return () => {
      mounted = false;
    };
  }, []);
 /*
  useEffect(() => {
    if (!token || !hacId || !languageReady) return;

    const fetchActiveSurvey = async () => {
      try {
        const surveysResponse = await apiClient.get(
          `${process.env.REACT_APP_API_URL}/surveys?hacId=${hacId}`
        );

        const surveys = Array.isArray(surveysResponse.data) ? surveysResponse.data : [];
        const currentActiveSurvey =
          surveys.find((survey) => survey.is_active === true) || null;

        setActiveSurvey(currentActiveSurvey);

        if (!currentActiveSurvey?.survey_id) {
          setSurveySubmission(null);
          setOpenSurveyModal(false);
          return;
        }

        const submissionStatus = currentActiveSurvey.status || null;

        const nextSubmission = {
          submission_id: currentActiveSurvey.submission_id || null,
          status: submissionStatus,
          started_at: currentActiveSurvey.started_at || null,
          last_saved_at: currentActiveSurvey.last_saved_at || null,
          submitted_at: currentActiveSurvey.submitted_at || null
        };

        setSurveySubmission(nextSubmission);

        const modalSessionKey = getSurveyModalSessionKey(currentActiveSurvey.survey_id);
        const alreadyShownThisSession =
          sessionStorage.getItem(modalSessionKey) === 'true';

        if (
          (submissionStatus === 'not_started' || submissionStatus === 'in_progress') &&
          !alreadyShownThisSession
        ) {
          setOpenSurveyModal(true);
          sessionStorage.setItem(modalSessionKey, 'true');
          return;
        }

        setOpenSurveyModal(false);
      } catch (error) {
        console.error('Error fetching active survey:', error);
        setOpenSurveyModal(false);
      }
    };

    fetchActiveSurvey();
  }, [token, hacId, languageReady]);

 
  const surveyModalContent = useMemo(() => {
    if (!languageReady || !activeSurvey?.survey_id || !surveySubmission?.status) {
      return { title: '', text: '' };
    }

    if (surveySubmission.status === 'not_started') {
      return {
        title: t(`survey${activeSurvey.survey_id}-modal-title`),
        text: t(`survey${activeSurvey.survey_id}-modal-text`)
      };
    }

    if (surveySubmission.status === 'in_progress') {
      return {
        title: t(`survey${activeSurvey.survey_id}-modal-title-continue`),
        text: t(`survey${activeSurvey.survey_id}-modal-text-continue`)
      };
    }

    return { title: '', text: '' };
  }, [activeSurvey?.survey_id, surveySubmission?.status, t, languageReady, i18n.resolvedLanguage]);

*

  const handleCloseSurveyModal = () => {
    setOpenSurveyModal(false);
  };

  const handleStartSurvey = async () => {
    if (!activeSurvey?.survey_id || !hacId || !token) return;

    try {
      let submissionIdToUse = surveySubmission?.submission_id ?? null;

      if (surveySubmission?.status === 'not_started') {
        const url = `${process.env.REACT_APP_API_URL}/surveys/${activeSurvey.survey_id}/start?hacId=${hacId}`;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Cache-Control': 'no-cache'
          }
        };

        const response = await apiClient.post(url, {}, config);
        const startData = response?.data || null;

        setSurveySubmission(startData);
        submissionIdToUse = startData?.submission_id ?? null;
      }

      setOpenSurveyModal(false);

      navigate('/hac/survey', {
        state: {
          surveyId: activeSurvey.survey_id,
          submissionId: submissionIdToUse
        }
      });
    } catch (error) {
      console.error('Error starting survey:', error);
    }
  };

  */

  const toggleSection = (section) => {
    if (innerWidth < 768) return;
    setActiveExperience((prev) => (prev === section ? null : section));
  };

  const getGalleryImage = () => {
    if (innerWidth < 768) {
      return hacLandingExperience01;
    }

    switch (activeExperience) {
      case 'experiences2':
        return hacLandingExperience02;
      case 'experiences3':
        return hacLandingExperience03;
      case 'experiences1':
      default:
        return hacLandingExperience01;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
/*
  const confirmButtonText = useMemo(() => {
    return surveySubmission?.status === 'in_progress'
      ? t('common-continue-survey')
      : t('common-start-survey');
  }, [surveySubmission?.status, t]);
*/
  const settingsContent = {
    responsive: [
      {
        breakpoint: 5000,
        settings: {
          infinite: false,
          focusOnSelect: true,
          accessibility: true,
          arrows: false,
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          infinite: false,
          focusOnSelect: true,
          accessibility: true,
          arrows: false
        }
      }
    ]
  };

  return (
    <>
      {token &&
      (role === 'hac' ||
        role === 'pmaGM' ||
        role === 'pma' ||
        role === 'retailerGM' ||
        role === 'retailer' ||
        role === 'admin' ||
        role === 'marketAdmin' ||
        role === 'countryAdmin' ||
        role === 'translator' ||
        role === 'reviewer') ? (
        <div className="App">
          <Header />
          <main className={`landing ${role !== 'hac' ? 'landing-no-hac' : ''}`}>
            {role === 'hac' && <Wadsworth />}

            <RoleRibbonByRole role={role} navigate={navigate} translate={t} context="clientView" />
            <section className="hero home">
              <div>
                <h1>
                  {t('hac-landing-hero-title')}
                  <small>{t('hac-landing-hero-subtitle')}</small>
                </h1>
              </div>
            </section>

            {role === 'hac' && (
              <section className="intro">
                <div className="inner">
                  <h2>{t('hac-landing-intro-title')}</h2>
                  <p>{t('hac-landing-intro-text')}</p>
                  <Link
                    to="/hac/profile/basic-info"
                    className="btn text landing-cta-2"
                    aria-label={t('landing-cta-2')}
                  >
                    <span className="icon-chevron-right"></span>
                    {t('landing-cta-2')}
                  </Link>
                </div>
              </section>
            )}

            <LandingElectricSection
              title={t('hac-landing-BEV-title')}
              text={t('hac-landing-BEV-text')}
              ctaLabel={t('hac-landing-BEV-button')}
              imageSrc={electricHero}
              onCtaClick={showContact}
            />

            <section className="gallery-experiences">
              <div className="inner">
                <h2>{t('hac-landing-gallery-title')}</h2>
                <p>{t('hac-landing-gallery-text')}</p>
                <div>
                  <div className="img">
                    <img src={getGalleryImage()} alt="" />
                  </div>
                  <div className="text">
                    <div className="title" onClick={() => toggleSection('experiences1')}>
                      <img src={hacLandingExperience01} alt="" />
                      <button className="btn text">
                        {activeExperience === 'experiences1' ? (
                          <span className="icon-minus"></span>
                        ) : (
                          <span className="icon-plus"></span>
                        )}
                      </button>
                      <p>{t('hac-landing-gallery-title-item1')}</p>
                    </div>
                    <Collapse in={activeExperience === 'experiences1'}>
                      <p>{t('hac-landing-gallery-text-item1')}</p>
                    </Collapse>

                    <div className="title" onClick={() => toggleSection('experiences2')}>
                      <img src={hacLandingExperience02} alt="" />
                      <button className="btn text">
                        {activeExperience === 'experiences2' ? (
                          <span className="icon-minus"></span>
                        ) : (
                          <span className="icon-plus"></span>
                        )}
                      </button>
                      <p>{t('hac-landing-gallery-title-item2')}</p>
                    </div>
                    <Collapse in={activeExperience === 'experiences2'}>
                      <p>{t('hac-landing-gallery-text-item2')}</p>
                    </Collapse>

                    <div className="title" onClick={() => toggleSection('experiences3')}>
                      <img src={hacLandingExperience03} alt="" />
                      <button className="btn text">
                        {activeExperience === 'experiences3' ? (
                          <span className="icon-minus"></span>
                        ) : (
                          <span className="icon-plus"></span>
                        )}
                      </button>
                      <p>{t('hac-landing-gallery-title-item3')}</p>
                    </div>
                    <Collapse in={activeExperience === 'experiences3'}>
                      <p>{t('hac-landing-gallery-text-item3')}</p>
                    </Collapse>
                  </div>
                </div>
                <p>
                  <a href="/hac/catalog" className="btn landing-cta-4">
                    <span className="text">{t('landing-cta-4')}</span>
                  </a>
                </p>
              </div>
            </section>

            <PartnerIntegrationSection
              title={t('geuer-geuer-title')}
              text={t('geuer-geuer-p')}
              ctaLabel={t('geuer-geuer-button')}
              imageSrc={partnerIntegration}
            />


            <section className="banner-products dark">
              <div className="content">
                <div className="inner">
                  <h2>{t('hac-landing-limitededition-title')}</h2>
                  <p>{t('hac-landing-limitededition-text')}</p>
                  <p>
                    <a href="/hac/catalog-limited-edition" className="btn text landing-cta-4">
                      <span className="icon-chevron-right"></span>
                      <span className="text">{t('hac-landing-limitededition-CTA')}</span>
                    </a>
                  </p>
                </div>
              </div>
            </section>

            <section className="benefits-new">
              <div className="inner">
                <h2>{t('hac-landing-benefits-title')}</h2>
                <p>{t('hac-landing-benefits-text')}</p>

                <Slider className="slider-landing" {...settingsContent}>
                  <div>
                    <div className="slide-beneficts slide1">
                      <div className={`slide-content ${activeBenefit === 1 ? 'is-visible' : ''}`}>
                        <button className="close" onClick={() => setActiveBenefit(null)}>
                          <span className="icon-close"></span>
                        </button>
                        <h5 className="range">{t('hac-landing-benefits-tab1-title')}</h5>
                        <div className="text">
                          <p dangerouslySetInnerHTML={{ __html: t('hac-landing-benefits-tab1-text') }}></p>
                          {role === 'hac' && (
                            <button className="btn text fit" onClick={showContact}>
                              <span className="text">
                                <span className="icon-chevron-right"></span> {t('landing-cta-1')}
                              </span>
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="slide-front" onClick={() => setActiveBenefit((prev) => (prev === 1 ? null : 1))}>
                        <strong>{t('hac-landing-benefits-tab1-tab')}</strong>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="slide-beneficts slide2">
                      <div className={`slide-content ${activeBenefit === 2 ? 'is-visible' : ''}`}>
                        <button className="close" onClick={() => setActiveBenefit(null)}>
                          <span className="icon-close"></span>
                        </button>
                        <h5 className="range">{t('hac-landing-benefits-tab2-title')}</h5>
                        <div className="text">
                          <p dangerouslySetInnerHTML={{ __html: t('hac-landing-benefits-tab2-text') }}></p>
                          {role === 'hac' && (
                            <button className="btn text fit" onClick={showContact}>
                              <span className="text">
                                <span className="icon-chevron-right"></span> {t('landing-cta-1')}
                              </span>
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="slide-front" onClick={() => setActiveBenefit((prev) => (prev === 2 ? null : 2))}>
                        <strong>{t('hac-landing-benefits-tab2-tab')}</strong>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="slide-beneficts slide3">
                      <div className={`slide-content ${activeBenefit === 3 ? 'is-visible' : ''}`}>
                        <button className="close" onClick={() => setActiveBenefit(null)}>
                          <span className="icon-close"></span>
                        </button>
                        <h5>{t('hac-landing-benefits-tab3-title')}</h5>
                        <div className="text">
                          <p dangerouslySetInnerHTML={{ __html: t('hac-landing-benefits-tab3-text') }}></p>
                        </div>
                      </div>
                      <div className="slide-front" onClick={() => setActiveBenefit((prev) => (prev === 3 ? null : 3))}>
                        <strong>{t('hac-landing-benefits-tab3-tab')}</strong>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="slide-beneficts slide4">
                      <div className={`slide-content ${activeBenefit === 4 ? 'is-visible' : ''}`}>
                        <button className="close" onClick={() => setActiveBenefit(null)}>
                          <span className="icon-close"></span>
                        </button>
                        <h5>{t('hac-landing-benefits-tab4-title')}</h5>
                        <div className="text">
                          <p>
                            <strong>{t('hac-landing-benefits-tab4-subTitle')}</strong>
                          </p>
                          <p dangerouslySetInnerHTML={{ __html: t('hac-landing-benefits-tab4-text') }}></p>
                          {role === 'hac' && (
                            <button className="btn text fit" onClick={showContact}>
                              <span className="text">
                                <span className="icon-chevron-right"></span> {t('landing-cta-1')}
                              </span>
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="slide-front" onClick={() => setActiveBenefit((prev) => (prev === 4 ? null : 4))}>
                        <strong>{t('hac-landing-benefits-tab4-tab')}</strong>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </section>
          </main>
          <Footer />
        </div>
      ) : (
        <Navigate to="/login" />
      )}

      <ModalHacShowContact
        open={openModal}
        handleClose={handleCloseModal}
        className="modal-contact"
      />

   {/*  <ModalWindow
        open={languageReady && openSurveyModal}
        handleClose={handleCloseSurveyModal}
        title={surveyModalContent.title}
        text={surveyModalContent.text}
        textButtonCancel={t('common-remind-later')}
        textoButtonConfirm={confirmButtonText}
        executeFunction={handleStartSurvey}
        postExecuteFunction={() => {}}
      />
*/}
    </>
  );
};

export default MainHac;